<div matSnackBarLabel>
  {{data.message}}
</div>

<div matSnackBarActions *ngIf="hasAction">
  <button mat-button matSnackBarAction (click)="action()">
    {{data.action}}
  </button>
</div>
